import { Loader } from '@googlemaps/js-api-loader'

/**
 * FIXME: This needs to come from an environment variable.
 */
const apiKey = 'AIzaSyA8LJlptsL88nHmrK_hWFVPNZEwFHe2djU'

/**
 * Create a new loader with the API Key set.
 */
const loader = new Loader({
    apiKey,
    version: 'weekly',
    libraries: ['places', 'geometry'],
})

/**
 * When finished loading, fire a load event.
 */
loader.load().then(() => {
    window.dispatchEvent(new Event('googlemapsapiready'))
})



// WEBPACK FOOTER //
// ./scripts/custom/google-maps-loader.js